export const supportedImageTypes = new Set([
    "image/png",
    "image/jpeg",
    "image/gif"
]);
